import { createRouter, createWebHashHistory } from "vue-router";
import { isMobile } from "@/utils/platform.js";

const routes = [
    {
        path: '/',
        name: 'Home',
        // component: () => isMobile() ? import('@/pages/home/mobile.vue') : import('@/pages/home/index.vue')
        component: () => import('@/pages/home/index.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/pages/user/login.vue')
    },
    {
        path: '/warning',
        name: 'Warning',
        component: () => import('@/pages/warning/index.vue')
    },
    {
        path: '/warning/sosDetail',
        name: 'SosDetail',
        component: () => import('@/pages/warning/bell/detail.vue')
    },
    {
        path: '/health/report',
        name: 'Detail',
        component: () => import('@/pages/health/report.vue')
    },
    {
        path: '/health/report/index',
        name: 'Detail2',
        component: () => import('@/pages/health/iframes/index.vue')
    },
    {
        path: '/health/report/curvs',
        name: 'Detail3',
        component: () => import('@/pages/health/iframes/curvs.vue')
    },
    {
        path: '/health/report/score',
        name: 'Detail4',
        component: () => import('@/pages/health/iframes/score.vue')
    },
    {
        path: '/health/report/eval',
        name: 'Detail5',
        component: () => import('@/pages/health/iframes/eval.vue')
    },
    {
        path: '/health',
        name: 'Health',
        component: () => import('@/pages/health/index.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes: routes
})

export default router;